import { ShapeType } from '@/enums/manage-vacations/manage-vacations.enum';

export type ManageVacationsCriteria = CriteriaCard[];

export class CriteriaCard {
  shape?: ShapeCard;
  title!: string;
  desc?: DescriptionCard[];
  people?: PeopleCard;
  tabs?: TabCard;
  order!: string[];
}

export class ShapeCard {
  type!: ShapeType;
  color!: string;
}

export class DescriptionCard {
  subtitle!: string;
  value!: string;
}

export class PeopleCard {
  subtitle!: string;
  person!: CardContent[];
}

export class CardContent {
  contentImg!: string;
  text!: string;
}

export class TabCard {
  subtitle!: string;
  pages!: PagesCardTab[];
}

export class PagesCardTab {
  key!: string;
  content!: CardContent[];
}
